/**
 * Erkennt einen eigenen Hostnamen fuer den IT-Katalog.
 *
 * Laeuft die Anwendung unter katalog.example.com, ist der Katalog die ganze
 * Anwendung: Mitarbeitende sollen dort nicht in einem Controllingwerkzeug
 * landen. Es bleibt dieselbe Anwendung mit derselben Anmeldung und denselben
 * Berechtigungen – getrennt ist ausschliesslich die Darstellung.
 *
 * Bewusst eine Regel ueber die erste Namensstufe statt einer weiteren
 * Konfigurationsvariablen: Ein zusaetzlicher Wert muesste in jeder Umgebung
 * gepflegt werden, und wer einen Hostnamen "katalog…" einrichtet, meint genau
 * das. Geprueft wird nur die erste Stufe, damit nicht jede Adresse umschaltet,
 * die das Wort irgendwo enthaelt.
 */
export function isCatalogHost(hostname: string): boolean {
  const first = hostname.split('.')[0]?.toLowerCase() ?? '';
  return first === 'katalog' || first === 'catalog';
}
